import moment from "moment";

import { type DateRangeChoiceV4 } from "@north-beam/nb-common";

export const QUICK_SELECT_OPTIONS: {
  value: DateRangeChoiceV4;
  label: string;
  relativeDate: () => moment.Moment;
}[] = [
  {
    value: "yesterday",
    label: "Yesterday",
    relativeDate: () => moment().tz(moment.tz.guess()).subtract(1, "day"),
  },
  {
    value: "today",
    label: "Today",
    relativeDate: () => moment().tz(moment.tz.guess()),
  },
  {
    value: "last3Days",
    label: "3 Day",
    relativeDate: () => moment().tz(moment.tz.guess()).subtract(3, "days"),
  },
  {
    value: "last7Days",
    label: "7 Day",
    relativeDate: () => moment().tz(moment.tz.guess()).subtract(7, "days"),
  },
  {
    value: "last14Days",
    label: "14 Day",
    relativeDate: () => moment().tz(moment.tz.guess()).subtract(14, "days"),
  },
  {
    value: "last30Days",
    label: "30 Day",
    relativeDate: () => moment().tz(moment.tz.guess()).subtract(30, "days"),
  },
  {
    value: "last60Days",
    label: "60 Day",
    relativeDate: () => moment().tz(moment.tz.guess()).subtract(60, "days"),
  },
  {
    value: "last6Months",
    label: "6 Month",
    relativeDate: () => moment().tz(moment.tz.guess()).subtract(6, "months"),
  },
  {
    value: "last12Months",
    label: "1 Year",
    relativeDate: () => moment().tz(moment.tz.guess()).subtract(1, "year"),
  },
  {
    value: "lastMonth",
    label: "Last Month",
    relativeDate: () =>
      moment().tz(moment.tz.guess()).subtract(1, "month").startOf("month"),
  },
  {
    value: "monthToDate",
    label: "Month to Date",
    relativeDate: () => moment().tz(moment.tz.guess()).startOf("month"),
  },
  {
    value: "yearToDate",
    label: "Year to Date",
    relativeDate: () => moment().tz(moment.tz.guess()).startOf("year"),
  },
];
